import { render, staticRenderFns } from "./WaybillImport.vue?vue&type=template&id=9679747c&scoped=true&"
import script from "./WaybillImport.vue?vue&type=script&lang=js&"
export * from "./WaybillImport.vue?vue&type=script&lang=js&"
import style0 from "./WaybillImport.vue?vue&type=style&index=0&id=9679747c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9679747c",
  null
  
)

export default component.exports